import {createAction, props} from "@ngrx/store";
import { LocalDate } from '@js-joda/core';
import { CancelTaskRequest, CreateTaskDefinitionRequest, ModifyTaskDefinitionRequest } from "@core/models/request/restriction.request";
import { TaskDefinition, TaskDefinitionStatus, TaskExecution, ParentTaskCancellation } from "@core/models/domain/restriction.domain";

// LOAD TASK DEFINITIONS
export const loadTaskDefinitions = createAction(
  "[TaskDefinition] Load TaskDefinitions",
  props<{ statuses: TaskDefinitionStatus[] }>()
);
export const loadTaskDefinitionsSuccess = createAction(
  "[TaskDefinition] Load TaskDefinitions Success",
   props<{ taskDefinitions: TaskDefinition[] }>()
);
export const loadTaskDefinitionsFailure = createAction(
  "[TaskDefinition] Load TaskDefinitions Failure",
  props<{ error: any }>()
);

// LOAD TASK EXECUTIONS
export const loadTaskExecutions = createAction(
    "[TaskExecution] Load TaskExecutions",
    props<{ date: LocalDate }>()
);
export const loadTaskExecutionsSuccess = createAction(
  "[TaskExecution] Load TaskExecutions Success",
  props<{ date: string, taskExecutions: TaskExecution[] }>()
);
export const loadTaskExecutionsFailure = createAction(
  "[TaskDefinition] Load TaskExecutions Failure",
  props<{ error: any }>()
);

// CREATE TASK DEFINITION
export const createTaskDefinition = createAction(
  "[TaskDefinition] Create TaskDefinition",
  props<{ request: CreateTaskDefinitionRequest }>()
);
export const createTaskDefinitionSuccess = createAction(
  "[TaskDefinition] Create TaskDefinition Success",
  props<{ taskDefinition: TaskDefinition }>()
);
export const createTaskDefinitionFailure = createAction(
    '[TaskDefinition] Create TaskDefinition Failure',
    props<{ error: any }>()
);

// UPDATE TASK DEFINITION
export const updateTaskDefinition = createAction(
  "[TaskDefinition] Update TaskDefinition",
  props<{ request: ModifyTaskDefinitionRequest }>()
);
export const updateTaskDefinitionSuccess = createAction(
  "[TaskDefinition] Update TaskDefinition Success",
  props<{ taskDefinition: TaskDefinition; request: ModifyTaskDefinitionRequest }>()
);
export const updateTaskDefinitionFailure = createAction(
    '[TaskDefinition] Update TaskDefinition Failure',
    props<{ error: any; request: ModifyTaskDefinitionRequest }>()
);

// CANCEL TASK
export const cancelTask = createAction(
    '[Task] Cancel Task',
    props<{ request: CancelTaskRequest; date: string }>()
);
export const cancelTaskSuccess = createAction(
    '[Task] Cancel Task Success',
    props<{ id: string; date: string }>()
);
export const cancelTaskFailure = createAction(
    '[Task] Cancel Task Failure',
    props<{ error: any; request: CancelTaskRequest; date: string }>()
);

// LOAD PARENT CANCELLATIONS
export const loadParentCancellations = createAction(
    '[ParentCancellation] Load Parent Cancellations',
    props<{ childId: string }>()
);
export const loadParentCancellationsSuccess = createAction(
    '[ParentCancellation] Load Parent Cancellations Success',
    props<{ cancellations: ParentTaskCancellation[] }>()
);
export const loadParentCancellationsFailure = createAction(
    '[ParentCancellation] Load Parent Cancellations Failure',
    props<{ error: any }>()
);

// LOAD SCHOOL PARENT CANCELLATIONS
export const loadSchoolParentCancellations = createAction(
    '[ParentCancellation] Load School Parent Cancellations'
);
export const loadSchoolParentCancellationsSuccess = createAction(
    '[ParentCancellation] Load School Parent Cancellations Success',
    props<{ cancellations: ParentTaskCancellation[] }>()
);
export const loadSchoolParentCancellationsFailure = createAction(
    '[ParentCancellation] Load School Parent Cancellations Failure',
    props<{ error: any }>()
);